/**
 *  Header props for the possible states.
 *
 *  We could infer the type through combinations of present and missing props,
 *  but using a type field is more explicit and easier to understand, even if
 *  the information is redundant.
 */
export enum HeaderType {
    ChromeExtension = "chrome-extension",
    DesktopChat = "desktop-chat",
    SmallScreenChat = "small-screen-chat",
    DesktopActivity = "desktop-activity",
    SmallScreenActivity = "small-screen-activity",
    AITools = "ai-tools",
}
